import { _ as __assign } from '../../chunks/bundle-Ca6003_X.js';
import React__default from 'react';
import { G as GroupChannelHeaderView } from '../../chunks/bundle-ByFIDXba.js';
import { b as useGroupChannelContext } from '../../chunks/bundle-CGu41Cov.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-zHBlW_wn.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../chunks/bundle-DMGc5oMP.js';
import '../../chunks/bundle-DvRfv6gQ.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '../../chunks/bundle-CPSJLEbT.js';
import '../../chunks/bundle-s19NuPaM.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DMyARZj7.js';
import '../../ui/IconButton.js';
import '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-Dwuqku8L.js';
import '../../chunks/bundle-DxuHs_7y.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../chunks/bundle-CyNQH9Yl.js';
import '../../chunks/bundle-B2eoNpzc.js';
import '../../chunks/bundle-_G98ZxIs.js';
import '../../chunks/bundle-CiiVQ3uH.js';

var GroupChannelHeader = function (props) {
    var context = useGroupChannelContext();
    return (React__default.createElement(GroupChannelHeaderView, __assign({}, props, context, { currentChannel: context.currentChannel })));
};

export { GroupChannelHeader, GroupChannelHeader as default };
//# sourceMappingURL=GroupChannelHeader.js.map
